import { render, staticRenderFns } from "./NewspaperVariantOutline.vue?vue&type=template&id=34295e5f"
import script from "./NewspaperVariantOutline.vue?vue&type=script&lang=js"
export * from "./NewspaperVariantOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports